// Using the browser specific directory router instance to assist builds to be faster
import { Router } from "director-fork/build/director";

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Function Router called at module scope is not allowed. This may cause unwanted side effects. */
const router: Router = new Router();
export default router;

/** Gets an array with the current route segments, including the vdir. */
export function getCurrentRoute(): string[] {
    return router.getRoute();
}

/**
 * Register a named URL parameter token with a custom regex matcher.
 * When the router encounters `:token` in a route, it will use the
 * provided regex instead of the default `([._a-zA-Z0-9-%()]+)`.
 * This allows differentiation between parameters that share the
 * same position in the route trie.
 */
export function registerRouteParam(token: string, matcher: RegExp): void {
    router.param(token, matcher);
}
